<template>
  <div
    class="html-text"
    v-html="value"
  />
</template>
<script>
export default {
  name: "WsHtmlText",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
};
</script>
